import "@/scss/styles.scss";
import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../.sourceflow/metadata.json";
import { AppHeader } from "@/components/AppHeader";
import { lazy } from "react";
import { useRouter } from "next/router";

const AppFooter = lazy(() => import("@/components/AppFooter"));

export default function App({ Component, pageProps }) {
  const router = useRouter();
  // Exclude `/components` page from being wrapped in Layout and SourceFlowHead
  const isComponentsPage = router.pathname === "/components";
  return isComponentsPage ? (
    <>
      <AppHeader />
      <main className="flex-grow-1">
        <Component {...pageProps} />
      </main>
      <AppFooter />
    </>
  ) : (
    <>
      <SourceFlowHead metaObject={metaObject} addTracker={true} cookieExpiryTime={3000}>
        {pageProps?.meta?.title && <title>{pageProps.meta.title}</title>}
      </SourceFlowHead>
      <AppHeader />
      <main className="flex-grow-1">
        <Component {...pageProps} />
      </main>
      <AppFooter />
    </>
  );
}
